<template>
    <div class="simulationOverrides">
        <h4 class="table-title">Modifier les paramètres de la simulation</h4>
        <el-form
            class="override-form"
            ref="form"
            :model="form"
        >
            <div
                v-for="(solution, index) in availableSolutions"
                :key="index"
            >
                <div
                    v-if="index === 0"
                    class="first-column"
                >
                    <div class="empty-column"></div>
                    <div 
                        class="column-name"
                    >
                        <div class="motor-name">{{ availableSolutionsNames[solution] }}</div>
                        <el-tooltip 
                            effect="light" 
                            popper-class="simulationCreationTooltip" 
                            :visible-arrow="false"
                            :content="getTooltipContent(solution)" 
                            placement="top"
                        >
                            <el-button
                                icon="el-icon-refresh-left"
                                size="mini"
                                @click="resetToInitalvalues(solution)"
                            ></el-button>
                        </el-tooltip>
                    </div>
                </div>
                <div 
                    v-else
                    class="column-name"
                >
                    <div class="motor-name">{{ availableSolutionsNames[solution] }}</div>
                    <el-tooltip 
                            effect="light" 
                            popper-class="simulationCreationTooltip" 
                            :visible-arrow="false"
                            :content="getTooltipContent(solution)" 
                            placement="top"
                        >
                            <el-button
                                icon="el-icon-refresh-left"
                                size="mini"
                                @click="resetToInitalvalues(solution)"
                            ></el-button>
                        </el-tooltip>
                </div>
                <el-form-item
                    :label="index===0?'Prix du moteur (€)':''"
                >
                    <CostInput
                        :ref="`${solution}motor`"
                        v-model="form[solution].motor"
                        :disabled="solution === 'current'"
                        :default-cost="costs[solution].motor"
                    ></CostInput>
                </el-form-item>
                <el-form-item
                    :label="index===0?'Prix du variateur (€)':''"
                >
                    <CostInput
                        :ref="`${solution}variator`"
                        v-model="form[solution].variator"
                        :default-cost="costs[solution].variator"
                    ></CostInput>
                </el-form-item>
                <el-form-item
                    :label="index===0?'Prix de l\'installation (€)':''"
                >
                    <CostInput
                        :ref="`${solution}installation`"
                        v-model="form[solution].installation"
                        :default-cost="costs[solution].installation"
                    ></CostInput>
                </el-form-item>
            </div>
        </el-form>
        <el-button
            type="text"
            class="restart blueButton"
            @click="restartSimulation"
        >Relancer la simulation</el-button>
        <el-button
            type="text"
            class="restart blueButton"
            @click="resetToInitalvalues(null)"
        >Revenir aux valeurs initiales</el-button>
    </div>
</template>

<script>
import CostInput from './CostInput.vue';
    export default {
        name: 'CostsForm',
        components: {
            CostInput
        },
        props:{
            costs:{
                type: Object,
                required: true,
            },
            initialCosts:{
                type: Object,
                required: true,
            },
        },
        data(){
            return{
                availableSolutions: ['current', 'ie2', 'ie3', 'ie4', 'msap'],
                availableSolutionsNames: {
                    'ie2':'IE2', 
                    'ie3':'IE3', 
                    'ie4':'IE4', 
                    'msap':'MSAP', 
                    'current': 'Moteur actuel'
                },
                form: null,
            }
        },
        created(){
            this.$set(this, 'form', {...this.costs})
        },
        methods:{
            restartSimulation(){
                this.$emit('restartSimulation', this.form)
            },
            resetForm(){
                this.$refs.form.resetFields()
            },
            getTooltipContent(value){
                let contents= {
                    ie2: 'Revenir aux valeurs initiales du moteur IE2',
                    ie3: 'Revenir aux valeurs initiales du moteur IE3',
                    ie4: 'Revenir aux valeurs initiales du moteur IE4',
                    msap: 'Revenir aux valeurs initiales du moteur MSAP',
                    current: 'Revenir aux valeurs initiales du moteur actuel',
                }
                return contents[value]
            },
            resetToInitalvalues(solution=null){
                if (Object.keys(this.initialCosts).length === 0){
                    this.$set(this, 'form',  {...this.costs})
                    this.availableSolutions.forEach(solution => {
                        this.$refs[`${solution}motor`][0].saveValue(this.form[solution].motor);
                        this.$refs[`${solution}variator`][0].saveValue(this.form[solution].variator);
                        this.$refs[`${solution}installation`][0].saveValue(this.form[solution].installation);
                    });
                }else if(solution === null){
                    this.$set(this, 'form', {...this.initialCosts})
                    this.availableSolutions.forEach(solution => {
                        this.$refs[`${solution}motor`][0].saveValue(this.form[solution].motor);
                        this.$refs[`${solution}variator`][0].saveValue(this.form[solution].variator);
                        this.$refs[`${solution}installation`][0].saveValue(this.form[solution].installation);
                    });
                }else{
                    this.$set(this.form[solution], 'motor', this.initialCosts[solution].motor);
                    this.$refs[`${solution}motor`][0].saveValue(this.form[solution].motor);
        
                    this.$set(this.form[solution], 'variator', this.initialCosts[solution].variator);
                    this.$refs[`${solution}variator`][0].saveValue(this.form[solution].variator);
        
                    this.$set(this.form[solution], 'installation', this.initialCosts[solution].installation);
                    this.$refs[`${solution}installation`][0].saveValue(this.form[solution].installation);
                }
            }
        }
    }
</script>

<style lang="scss">
.simulationOverrides{
    margin: 0;
    .restart {
        margin-top: 20px;
    }
    .override-form{
        background-color: white;
        display: flex;
        gap:2rem;
        padding: 0 1rem;
        .first-column{
            display: flex;
            .empty-column{
                flex-grow: 1;
            }
            .column-name{
                width: 160px;
            }
        }
        .column-name{
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #005BBA;
            text-align: center;
            height: 30px;
            margin: 1rem 0;
            .motor-name{
                flex-grow: 1;
                text-align: center;
            }
            .el-button{
                color: #005BBA;
                border-color: #005BBA;
                margin-left: 1rem;
                margin-bottom: 0.5rem;
                &:hover{
                    background-color: #005BBA30;
                }
            }
        }
        .el-form-item{
            display: flex;
            &__label{
                flex-grow: 1;
                margin: 0;
                width: auto;
                margin-right: 20px;
                // height: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                transition: all 0.4s;
                font-weight: 400;
                text-align: left;
            }
            .el-input{
                max-width: 160px;
            }
        }
    }
    .blueButton {
        border: none;
        text-transform: uppercase;
        font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px 0px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 3px 1px -2px;
        background: #005BBA;
        color: white !important;
        padding: 1rem;
        &.is-disabled {
            background: #005BBA;
            opacity: 0.5;
            &:hover {
                background: #005BBA;
                opacity: 0.5;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/partials/EnergeticGains/CostsForm.vue